$(document).ready(function () {
  // When a radio button is selected
  $('input[name="quantity"]').on("change", function () {
    // Get the value of the selected radio button
    var selectedQuantity = $('input[name="quantity"]:checked').val();

    // Update the hidden quantity input field with the selected value
    $('input[name="quantity"][type="number"]').val(selectedQuantity);
  });

  // Initialize the hidden quantity input value on page load
  var initialQuantity = $('input[name="quantity"]:checked').val();
  if (initialQuantity) {
    $('input[name="quantity"][type="number"]').val(initialQuantity);
  }

  // Add event listener for variant change
  document.querySelectorAll('.mak__change').forEach(radio => {
    radio.addEventListener('change', () => {
      console.log('variant change');
      
      // Uncheck all quantity radio buttons
      $('input[name="quantity"]').prop('checked', false);

      // Check the first radio button
      var firstRadio = $('input[name="quantity"]').first();
      firstRadio.prop('checked', true).trigger('change'); // Trigger change event to update the quantity input
    });
  });
});
